import { capitalize } from 'lodash'
import React, { FC, useCallback, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { get } from 'src/apis/apiService'
import routes from 'src/routes'
import { ON_DEMAND_APIS } from '../../../apis/onDemandApi'
import { setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import { MOBILE_THRESHOLD } from '../../../styles/theme'
import { useWindowSize } from '../../../utils/useWindowSize'
import LoadIcon from '../../LoadIcon'
import { Loader } from '../../shared/Loader'
import { ListItem } from './ListItem'

export const VideoSubmissionList: FC<RouteComponentProps> = ({ match }) => {
  const areaOfInterest = match.params['areaOfInterest']
  const dispatch = useDispatch()
  const [pageLoading, setPageLoading] = useState<boolean>(false)
  const { windowWidth, windowHeight } = useWindowSize()
  const [videos, setVideos] = useState([])

  const fetchVideos = useCallback(() => {
    get(
      ON_DEMAND_APIS.VIDEOS,
      (data) => {
        setPageLoading(false)
        setVideos(data.videos)
      },
      (error) => {
        setPageLoading(false)
        console.error(error)
      }, {}
    )
  }, [dispatch])

  useEffect(() => {
    dispatch(setPreviousPage(routes.onDemand))
  }, [dispatch])

  useEffect(() => {
    dispatch(setPageTitle('How I Do It'))
    setPageLoading(true)
    fetchVideos()
  }, [areaOfInterest, dispatch])
  
  const infiniteScrollHeight = windowHeight - (windowWidth <= MOBILE_THRESHOLD ? 120 : 110)

  return (
    <Loader fullPage loading={pageLoading}>
      <InfiniteScroll
        height={infiniteScrollHeight}
        dataLength={videos.length}
        next={() => console.log(videos.length)}
        hasMore={false}
        loader={
          <div className="position-relative my-5">
            <LoadIcon />
          </div>
        }
        endMessage={<p className="text-center text-muted">-- End --</p>}
        scrollThreshold={0.9}
      >
        <>
          {videos.map((poster) => (
            <ListItem key={poster.id} abstractType="video" title={poster.title} subtitle={capitalize(poster.presenting_submitter_name)} abstractId={poster.id} />
          ))}
        </>
      </InfiniteScroll>
    </Loader>
  )
}
